import React, { useState } from 'react';
import { css } from '@emotion/react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core';
import { FilterList, FiberManualRecord } from '@material-ui/icons';
import { greens, oranges, reds, greys } from '@/styles/colors';

const LEVEL_COLOR = {
    red: reds.primary,
    orange: oranges.primary,
    green: greens.primary,
};

const LEVEL_ORDER = ['red', 'orange', 'green'];

const StatusFilter = ({ value, onChange, labels }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = !!anchorEl;

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleSelect = (level) => () => {
        onChange(level);
        handleClose();
    };

    const activeColor = value ? LEVEL_COLOR[value] : null;
    const tooltip = value ? `Filtered: ${labels[value]}` : 'Filter';

    return (
        <>
            <Tooltip title={tooltip} placement="top">
                <IconButton size="small" onClick={handleOpen}>
                    <FilterList
                        css={css`
                            color: ${activeColor || greys[2]};
                            font-size: 18px;
                        `}
                    />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                getContentAnchorEl={null}
            >
                <MenuItem onClick={handleSelect(null)} selected={!value} dense>
                    <ListItemText primary="All" />
                </MenuItem>
                {LEVEL_ORDER.map((level) => (
                    <MenuItem key={level} onClick={handleSelect(level)} selected={value === level} dense>
                        <ListItemIcon
                            css={css`
                                min-width: 28px;
                            `}
                        >
                            <FiberManualRecord
                                css={css`
                                    color: ${LEVEL_COLOR[level]};
                                    font-size: 14px;
                                `}
                            />
                        </ListItemIcon>
                        <ListItemText primary={labels[level]} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default StatusFilter;
